// @flow

import type { Action } from '../store.type';

export const GET_NOTIFICATIONS_REQUEST = 'GET_NOTIFICATIONS_REQUEST';
type GET_NOTIFICATIONS_REQUEST_TYPE = 'GET_NOTIFICATIONS_REQUEST';

export const GET_NOTIFICATIONS_SUCCESS = 'GET_NOTIFICATIONS_SUCCESS';
type GET_NOTIFICATIONS_SUCCESS_TYPE = 'GET_NOTIFICATIONS_SUCCESS';

export const GET_NOTIFICATIONS_FAILURE = 'GET_NOTIFICATIONS_FAILURE';
type GET_NOTIFICATIONS_FAILURE_TYPE = 'GET_NOTIFICATIONS_FAILURE';

type GetNotificationsSuccess = {
  data: Object
};

type GetNotificationsFailure = {
  error: any
};

type GetNotificationsRequestAction = Action<GET_NOTIFICATIONS_REQUEST_TYPE, null>;

type GetNotificationsSuccessAction = Action<
  GET_NOTIFICATIONS_SUCCESS_TYPE,
  GetNotificationsSuccess
>;

type GetNotificationsFailureAction = Action<
  GET_NOTIFICATIONS_FAILURE_TYPE,
  GetNotificationsFailure
>;

type NotificationInfoType = {
  id: number,
  title: string,
  type: string,
  content: string,
  action: string
};

export type GetNotificationsState = {
  loading: boolean,
  success: boolean,
  error: any,
  list: Array<NotificationInfoType>
};

export type GetNotificationsAction =
  | GetNotificationsRequestAction
  | GetNotificationsSuccessAction
  | GetNotificationsFailureAction;

// Dismiss notification
export const DISMISS_NOTIFICATION_REQUEST = 'DISMISS_NOTIFICATION_REQUEST';
